import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../config";

function MediaList() {
    const [medias, setMedias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const fetchMedias = async () => {
        try {
            const response = await axios.get(
                `${config.BASE_URL}/api/admin/get-medias`,
                { withCredentials: true }
            );

            if (response.data) {
                setMedias(response.data);
            }
        } catch (err) {
            setError("Failed to fetch media");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMedias();
    }, []);

    return (
        <div className="dashboard">
            <div className="container">
                <h1 className="dash_title">Media Gallery</h1>

                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">

                            <header className="projects-header">
                                <div className="title">
                                    Total
                                    <div className="count">
                                        {medias.length} Media Items
                                    </div>
                                </div>

                                <div className="project_search">
                                    <form>
                                        <input
                                            type="text"
                                            name="search"
                                            placeholder="Search Media"
                                        />
                                        <button
                                            type="submit"
                                            className="btn"
                                        >
                                            Search
                                        </button>
                                    </form>
                                </div>

                                <div className="add_project">
                                    <Link to="/admin/add-media">
                                        Add Media
                                    </Link>
                                </div>
                            </header>

                            <table className="projects-table">
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Media File</th>
                                        <th className="text-right">
                                            Actions
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="4">
                                                Loading...
                                            </td>
                                        </tr>
                                    ) : error ? (
                                        <tr>
                                            <td colSpan="4">
                                                {error}
                                            </td>
                                        </tr>
                                    ) : medias.length === 0 ? (
                                        <tr>
                                            <td colSpan="4">
                                                No Media Found
                                            </td>
                                        </tr>
                                    ) : (
                                        medias.map((media) => (
                                            <tr key={media._id}>
                                                <td>
                                                    <p>{media.title}</p>
                                                </td>

                                               

                                                <td>
                                                    {media.mediafile ? (
                                                        <img
                                                            src={`${config.BASE_URL}${media.mediafile}`}
                                                            alt={media.title}
                                                            width="60"
                                                            height="60"
                                                            style={{
                                                                objectFit: "cover",
                                                            }}
                                                        />
                                                    ) : (
                                                        "No File"
                                                    )}
                                                </td>

                                                <td>
                                                    <Link
                                                        to={`/admin/media/${media._id}`}
                                                        className="view_detail"
                                                    >
                                                        View Details
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>

                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MediaList;